// extracted by mini-css-extract-plugin
export default {"root":"LYYp0Q","overlay":"vk69cs","info":"lu0B6D","item":"IZaH1y","image":"GlSRxp"};